import { createFileRoute } from "@tanstack/react-router";
import { AttendanceSettings } from "@/components/settings/attendance-settings";
import { companyQuery } from "@/lib/loaders";

export const Route = createFileRoute("/_workspace/settings/attendance")({
  loader: ({ context }) => context.queryClient.ensureQueryData(companyQuery),
  component: AttendanceSettings,
});
